/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2025, Zumper
 * @description  Constants for sweetDeals module
 */

export const DONE_FETCHING_SWEET_DEALS = '@@nzr/sweetDeals/DONE_FETCHING_SWEET_DEALS'
export const ERROR_FETCHING_SWEET_DEALS = '@@nzr/sweetDeals/ERROR_FETCHING_SWEET_DEALS'
export const RECEIVE_SWEET_DEALS = '@@nzr/sweetDeals/RECEIVE_SWEET_DEALS'
export const START_FETCHING_SWEET_DEALS = '@@nzr/sweetDeals/START_FETCHING_SWEET_DEALS'
